import { EnumFeatureFlagName } from '@blank/api'
import { EnumRoutes } from 'modules/common/routes'
import { useFeatureFlagQuery } from 'modules/corporate/queries/useFeatureFlagQuery'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const ONBOARDING_ROUTES: string[] = [
  // Signup routes (non-authenticated)
  EnumRoutes.SIGNUP_INFORMATION,
  EnumRoutes.SIGNUP_DOMICILIATION,
  EnumRoutes.QUICK_SIGNUP,
  EnumRoutes.MANAGEMENT_TOOLS_SIGNUP,
  // Post-signup onboarding routes (authenticated)
  EnumRoutes.MANDATORY_INFORMATION,
  EnumRoutes.EMAIL_VERIFICATION,
  EnumRoutes.EMAIL_CONFIRMATION_ROUTE,
  EnumRoutes.SECURING_DEVICE,
  EnumRoutes.OFFER_SELECTION,
  EnumRoutes.KYC_ROOT,
]

export const useCloseOnboardingGuard = () => {
  const router = useRouter()
  const isOnboardingRoute = ONBOARDING_ROUTES.includes(router.route)

  const closeOnboardingFeatureFlag = useFeatureFlagQuery(
    EnumFeatureFlagName.CLOSE_ONBOARDING,
    { enabled: isOnboardingRoute }
  )

  const isCloseOnboardingEnabled =
    closeOnboardingFeatureFlag.data?.body.enabled === true

  const isLoading = closeOnboardingFeatureFlag.isLoading

  useEffect(() => {
    if (isCloseOnboardingEnabled && isOnboardingRoute) {
      router.replace(EnumRoutes.ONBOARDING_CLOSED)
    }
  }, [isCloseOnboardingEnabled, isOnboardingRoute, router])

  return {
    isBlocking: isOnboardingRoute && (isLoading || isCloseOnboardingEnabled),
  }
}
